import mySuxApi from '../services/dataSources/mySuxApi';

// configs
import { config } from '../config';

function error(userGuid, error, message = 'Undefined error') {
  const url = `${config.URLS.MY_SOFOLOGY_API}${userGuid}/ErrorLog`;
  return mySuxApi.post(url, { message });
}

const log = {
  error
};

export default log;



// WEBPACK FOOTER //
// ./src/utilities/log.js